import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  ElementRef,
  input,
  model,
  viewChildren,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailsHistorieTab } from '../../models/details-historie.model';
import { SectionTitleComponent } from '../section-title/section-title.component';
import { DetailsHistoriePanelDirective } from './details-historie-panel.directive';

@Component({
  selector: 'app-details-historie-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TranslatePipe, SectionTitleComponent],
  templateUrl: './details-historie-card.component.html',
  styleUrl: './details-historie-card.component.scss',
})
export class DetailsHistorieCardComponent {
  readonly tabs = input<DetailsHistorieTab[]>([]);
  readonly activeTab = model<string>('');
  readonly title = input<string | null>(null);
  readonly subtitle = input<string>('');
  readonly testId = input.required<string>();

  private readonly panels = contentChildren(DetailsHistoriePanelDirective, { descendants: true });
  private readonly buttons = viewChildren<ElementRef<HTMLButtonElement>>('reiterButton');

  protected readonly aktiveId = computed(() => {
    const tabs = this.tabs();
    return tabs.some((tab) => tab.id === this.activeTab()) ? this.activeTab() : (tabs[0]?.id ?? '');
  });
  protected readonly aktivesPanel = computed(
    () => this.panels().find((panel) => panel.id() === this.aktiveId())?.template ?? null,
  );

  protected waehle(id: string): void {
    if (id !== this.aktiveId()) this.activeTab.set(id);
  }

  protected onKeydown(event: KeyboardEvent, index: number): void {
    const ziel = this.zielIndex(event.key, index);
    if (ziel === null) return;
    event.preventDefault();
    this.waehle(this.tabs()[ziel].id);
    this.buttons()[ziel].nativeElement.focus();
  }

  protected tabId(id: string): string {
    return `${this.testId()}-tab-${id}`;
  }

  protected panelId(id: string): string {
    return `${this.testId()}-panel-${id}`;
  }

  private zielIndex(key: string, index: number): number | null {
    const anzahl = this.tabs().length;
    switch (key) {
      case 'ArrowRight':
        return (index + 1) % anzahl;
      case 'ArrowLeft':
        return (index - 1 + anzahl) % anzahl;
      case 'Home':
        return 0;
      case 'End':
        return anzahl - 1;
      default:
        return null;
    }
  }
}
